export * from '@devstroupe/services/splash-screen/public-api';
